import { AttachmentResourceType } from '@/types'
import { Query as ShowQuery } from './show_query'
import { Collection as AttachmentsCollection } from '@/components/attachment/collection'

interface Props {
  id: string
}

export const EditAttachments = ({ id }: Props) => {
  return (
    <AttachmentsCollection
      filters={{ nameEq: 'attachments', resourceIdEq: id, resourceTypeEq: AttachmentResourceType.Asset }}
      pageSize={10}
      refetchQueries={[ShowQuery]}
      title="Attachments"
      createable
      deleteable
      fixedHeight
    />
  )
}
